import React from 'react';
import styled from '@emotion/styled';

// #FECF2F

const Container = styled.div`
    color: #182d3c;
    text-align: center;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const Text = styled.h1`
    font-family: Helvetica Neue, Helvetica, 'open sans', Arial, sans-serif;
    font-size: 26px;
    font-weight: 300;
    margin: 16px 0;
    text-transform: uppercase;
`;

export default function AAACTitle() {
    return (
        <Container>
            <img src={require('./rac.png')} style={{ height: 56, margin: '5px 20px' }} />{' '}
            <Text>Livetrack</Text>
        </Container>
    );
}
